import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateStockOut(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateStockOutAttempt', handleCreateStockOut, api);
}

function* handleCreateStockOut(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        branchId,
        productId,
        amount,
        serialNoId,
    } = reduxState.gold.params.createStockOutParams;

    const response = yield* call([api, api.createStockOut], {
        authToken,
        branchId,
        productId,
        amount,
        serialNoId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateStockOutFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success(SuccessMessages.GoldCreateInventorySuccess);
        yield put(combinedActions.goldSetIsCreateStockOutModalOpen(false));
        yield put(combinedActions.goldCreateStockOutSuccess());
        yield put(combinedActions.goldGetStockOutsAttempt());
    }
}
